import * as yup from 'yup';

export const CURRENCY_LIST = [
  {
    value: 'USD',
    label: 'US Dollar',
    name_plural: 'US dollars',
    symbol: '$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'popular',
    rounding: 0,
  },
  {
    value: 'EUR',
    label: 'Euro',
    name_plural: 'euros',
    symbol: '€',
    symbol_native: '€',
    decimal_digits: 2,
    category: 'popular',
    rounding: 0,
  },
  {
    value: 'GBP',
    label: 'British Pound Sterling',
    name_plural: 'British pounds sterling',
    symbol: '£',
    symbol_native: '£',
    decimal_digits: 2,
    category: 'popular',
    rounding: 0,
  },
  {
    value: 'AED',
    label: 'United Arab Emirates Dirham',
    name_plural: 'UAE dirhams',
    symbol: 'AED',
    symbol_native: 'د.إ.‏',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'AFN',
    label: 'Afghan Afghani',
    name_plural: 'Afghan Afghanis',
    symbol: 'Af',
    symbol_native: '؋',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'XCD',
    label: 'Eastern Caribbean Dollar',
    name_plural: 'Eastern Caribbean Dollars',
    symbol: 'EC$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'ALL',
    label: 'Albanian Lek',
    name_plural: 'Albanian lekë',
    symbol: 'ALL',
    symbol_native: 'Lek',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'AMD',
    label: 'Armenian Dram',
    name_plural: 'Armenian drams',
    symbol: 'AMD',
    symbol_native: 'դր.',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'AOA',
    label: 'Angolan Kwanza',
    name_plural: 'Angolan Kwanza',
    symbol: 'Kz',
    symbol_native: 'Kz',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'ARS',
    label: 'Argentine Peso',
    name_plural: 'Argentine pesos',
    symbol: 'AR$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'AUD',
    label: 'Australian Dollar',
    name_plural: 'Australian dollars',
    symbol: 'AU$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'AWG',
    label: 'Aruban Florin',
    name_plural: 'Aruban Florin',
    symbol: 'Afl.',
    symbol_native: 'Afl.',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'AZN',
    label: 'Azerbaijani Manat',
    name_plural: 'Azerbaijani manats',
    symbol: 'man.',
    symbol_native: 'ман.',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BAM',
    label: 'Bosnia-Herzegovina Convertible Mark',
    name_plural: 'Bosnia-Herzegovina convertible marks',
    symbol: 'KM',
    symbol_native: 'KM',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BBD',
    label: 'Barbadian Dollar',
    name_plural: 'Barbadian dollars',
    symbol: 'Bds$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BDT',
    label: 'Bangladeshi Taka',
    name_plural: 'Bangladeshi takas',
    symbol: 'Tk',
    symbol_native: '৳',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'XOF',
    label: 'CFA Franc BCEAO',
    name_plural: 'CFA francs BCEAO',
    symbol: 'CFA',
    symbol_native: 'CFA',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BGN',
    label: 'Bulgarian Lev',
    name_plural: 'Bulgarian leva',
    symbol: 'BGN',
    symbol_native: 'лв.',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BHD',
    label: 'Bahraini Dinar',
    name_plural: 'Bahraini dinars',
    symbol: 'BD',
    symbol_native: 'د.ب.‏',
    decimal_digits: 3,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BIF',
    label: 'Burundian Franc',
    name_plural: 'Burundian francs',
    symbol: 'FBu',
    symbol_native: 'FBu',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BMD',
    label: 'Bermudian Dollar',
    name_plural: 'Bermudian dollars',
    symbol: 'BD$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BND',
    label: 'Brunei Dollar',
    name_plural: 'Brunei dollars',
    symbol: 'BN$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BOB',
    label: 'Bolivian Boliviano',
    name_plural: 'Bolivian bolivianos',
    symbol: 'Bs',
    symbol_native: 'Bs',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BRL',
    label: 'Brazilian Real',
    name_plural: 'Brazilian reals',
    symbol: 'R$',
    symbol_native: 'R$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BSD',
    label: 'Bahamian Dollar',
    name_plural: 'Bahamian dollars',
    symbol: 'B$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BTN',
    label: 'Bhutanese Ngultrum',
    name_plural: 'Bhutanese ngultrum',
    symbol: 'Nu.',
    symbol_native: 'Nu.',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'NOK',
    label: 'Norwegian Krone',
    name_plural: 'Norwegian kroner',
    symbol: 'Nkr',
    symbol_native: 'kr',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BWP',
    label: 'Botswanan Pula',
    name_plural: 'Botswanan pulas',
    symbol: 'BWP',
    symbol_native: 'P',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BYN',
    label: 'Belarusian Ruble',
    name_plural: 'Belarusian rubles',
    symbol: 'Br',
    symbol_native: 'руб.',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'BZD',
    label: 'Belize Dollar',
    name_plural: 'Belize dollars',
    symbol: 'BZ$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'CAD',
    label: 'Canadian Dollar',
    name_plural: 'Canadian dollars',
    symbol: 'CA$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'CDF',
    label: 'Congolese Franc',
    name_plural: 'Congolese francs',
    symbol: 'CDF',
    symbol_native: 'FrCD',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'XAF',
    label: 'CFA Franc BEAC',
    name_plural: 'CFA francs BEAC',
    symbol: 'FCFA',
    symbol_native: 'FCFA',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'CHF',
    label: 'Swiss Franc',
    name_plural: 'Swiss francs',
    symbol: 'CHF',
    symbol_native: 'CHF',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'NZD',
    label: 'New Zealand Dollar',
    name_plural: 'New Zealand dollars',
    symbol: 'NZ$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'CLP',
    label: 'Chilean Peso',
    name_plural: 'Chilean pesos',
    symbol: 'CL$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'CNY',
    label: 'Chinese Yuan',
    name_plural: 'Chinese yuan',
    symbol: 'CN¥',
    symbol_native: 'CN¥',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'COP',
    label: 'Colombian Peso',
    name_plural: 'Colombian pesos',
    symbol: 'CO$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'CRC',
    label: 'Costa Rican Colón',
    name_plural: 'Costa Rican colóns',
    symbol: '₡',
    symbol_native: '₡',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'CUP',
    label: 'Cuban Peso',
    name_plural: 'Cuban pesoes',
    symbol: '$MN',
    symbol_native: '₱',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'CVE',
    label: 'Cape Verdean Escudo',
    name_plural: 'Cape Verdean escudos',
    symbol: 'CV$',
    symbol_native: 'CV$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'ANG',
    label: 'Netherlands Antillean Guilder',
    name_plural: 'Netherlands Antillean guilders',
    symbol: 'NAƒ',
    symbol_native: 'ƒ',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'CZK',
    label: 'Czech Republic Koruna',
    name_plural: 'Czech Republic korunas',
    symbol: 'Kč',
    symbol_native: 'Kč',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'DJF',
    label: 'Djiboutian Franc',
    name_plural: 'Djiboutian francs',
    symbol: 'Fdj',
    symbol_native: 'Fdj',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'DKK',
    label: 'Danish Krone',
    name_plural: 'Danish kroner',
    symbol: 'Dkr',
    symbol_native: 'kr',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'DOP',
    label: 'Dominican Peso',
    name_plural: 'Dominican pesos',
    symbol: 'RD$',
    symbol_native: 'RD$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'DZD',
    label: 'Algerian Dinar',
    name_plural: 'Algerian dinars',
    symbol: 'DA',
    symbol_native: 'د.ج.‏',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'EGP',
    label: 'Egyptian Pound',
    name_plural: 'Egyptian pounds',
    symbol: 'EGP',
    symbol_native: 'ج.م.‏',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MAD',
    label: 'Moroccan Dirham',
    name_plural: 'Moroccan dirhams',
    symbol: 'MAD',
    symbol_native: 'د.م.‏',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'ERN',
    label: 'Eritrean Nakfa',
    name_plural: 'Eritrean nakfas',
    symbol: 'Nfk',
    symbol_native: 'Nfk',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'ETB',
    label: 'Ethiopian Birr',
    name_plural: 'Ethiopian birrs',
    symbol: 'Br',
    symbol_native: 'Br',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'FJD',
    label: 'Fijian Dollar',
    name_plural: 'Fijian dollars',
    symbol: 'FJ$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'FKP',
    label: 'Falkland Islands Pound',
    name_plural: 'Falkland Islands pound',
    symbol: 'FK£',
    symbol_native: '£',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'GEL',
    label: 'Georgian Lari',
    name_plural: 'Georgian laris',
    symbol: 'GEL',
    symbol_native: 'GEL',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'GHS',
    label: 'Ghanaian Cedi',
    name_plural: 'Ghanaian cedis',
    symbol: 'GH₵',
    symbol_native: 'GH₵',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'GIP',
    label: 'Gibraltar Pound',
    name_plural: 'Gibraltar pounds',
    symbol: '£',
    symbol_native: '£',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'GMD',
    label: 'Gambian Dalasi',
    name_plural: 'Gambian dalasis',
    symbol: 'D',
    symbol_native: 'D',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'GNF',
    label: 'Guinean Franc',
    name_plural: 'Guinean francs',
    symbol: 'FG',
    symbol_native: 'FG',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'GTQ',
    label: 'Guatemalan Quetzal',
    name_plural: 'Guatemalan quetzals',
    symbol: 'GTQ',
    symbol_native: 'Q',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'GYD',
    label: 'Guyanese Dollar',
    name_plural: 'Guyanese dollars',
    symbol: 'GY$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'HKD',
    label: 'Hong Kong Dollar',
    name_plural: 'Hong Kong dollars',
    symbol: 'HK$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'HNL',
    label: 'Honduran Lempira',
    name_plural: 'Honduran lempiras',
    symbol: 'HNL',
    symbol_native: 'L',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'HRK',
    label: 'Croatian Kuna',
    name_plural: 'Croatian kunas',
    symbol: 'kn',
    symbol_native: 'kn',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'HTG',
    label: 'Haitian Gourde',
    name_plural: 'Haitian gourde',
    symbol: 'G',
    symbol_native: 'G',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'HUF',
    label: 'Hungarian Forint',
    name_plural: 'Hungarian forints',
    symbol: 'Ft',
    symbol_native: 'Ft',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'IDR',
    label: 'Indonesian Rupiah',
    name_plural: 'Indonesian rupiahs',
    symbol: 'Rp',
    symbol_native: 'Rp',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'ILS',
    label: 'Israeli New Sheqel',
    name_plural: 'Israeli new sheqels',
    symbol: '₪',
    symbol_native: '₪',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'INR',
    label: 'Indian Rupee',
    name_plural: 'Indian rupees',
    symbol: 'Rs',
    symbol_native: '₹',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'IQD',
    label: 'Iraqi Dinar',
    name_plural: 'Iraqi dinars',
    symbol: 'IQD',
    symbol_native: 'د.ع.‏',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'IRR',
    label: 'Iranian Rial',
    name_plural: 'Iranian rials',
    symbol: 'IRR',
    symbol_native: '﷼',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'ISK',
    label: 'Icelandic Króna',
    name_plural: 'Icelandic krónur',
    symbol: 'Ikr',
    symbol_native: 'kr',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'JMD',
    label: 'Jamaican Dollar',
    name_plural: 'Jamaican dollars',
    symbol: 'J$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'JOD',
    label: 'Jordanian Dinar',
    name_plural: 'Jordanian dinars',
    symbol: 'JD',
    symbol_native: 'د.أ.‏',
    decimal_digits: 3,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'JPY',
    label: 'Japanese Yen',
    name_plural: 'Japanese yen',
    symbol: '¥',
    symbol_native: '￥',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'KES',
    label: 'Kenyan Shilling',
    name_plural: 'Kenyan shillings',
    symbol: 'Ksh',
    symbol_native: 'Ksh',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'KGS',
    label: 'Kyrgyzstani Som',
    name_plural: 'Kyrgyzstani som',
    symbol: 'С̲ ',
    symbol_native: 'С̲ ',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'KHR',
    label: 'Cambodian Riel',
    name_plural: 'Cambodian riels',
    symbol: 'KHR',
    symbol_native: '៛',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'KMF',
    label: 'Comorian Franc',
    name_plural: 'Comorian francs',
    symbol: 'CF',
    symbol_native: 'FC',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'KPW',
    label: 'North Korean Won',
    name_plural: 'North Korean won',
    symbol: '₩',
    symbol_native: '₩',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'KRW',
    label: 'South Korean Won',
    name_plural: 'South Korean won',
    symbol: '₩',
    symbol_native: '₩',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'KWD',
    label: 'Kuwaiti Dinar',
    name_plural: 'Kuwaiti dinars',
    symbol: 'KD',
    symbol_native: 'د.ك.‏',
    decimal_digits: 3,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'KYD',
    label: 'Cayman Islands Dollar',
    name_plural: 'Cayman Islands dollars',
    symbol: 'CI$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'KZT',
    label: 'Kazakhstani Tenge',
    name_plural: 'Kazakhstani tenges',
    symbol: 'KZT',
    symbol_native: 'тңг.',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'LAK',
    label: 'Lao Kip',
    name_plural: 'Lao kip',
    symbol: '₭N',
    symbol_native: '₭',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'LBP',
    label: 'Lebanese Pound',
    name_plural: 'Lebanese pounds',
    symbol: 'LB£',
    symbol_native: 'ل.ل.‏',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'LKR',
    label: 'Sri Lankan Rupee',
    name_plural: 'Sri Lankan rupees',
    symbol: 'SLRs',
    symbol_native: 'SL Re',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'LRD',
    label: 'Liberian Dollar',
    name_plural: 'Liberian dollars',
    symbol: 'LD$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'LSL',
    label: 'Lesotho Loti',
    name_plural: 'Lesotho maloti',
    symbol: 'L',
    symbol_native: 'L',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'LYD',
    label: 'Libyan Dinar',
    name_plural: 'Libyan dinars',
    symbol: 'LD',
    symbol_native: 'د.ل.‏',
    decimal_digits: 3,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MDL',
    label: 'Moldovan Leu',
    name_plural: 'Moldovan lei',
    symbol: 'MDL',
    symbol_native: 'MDL',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MGA',
    label: 'Malagasy Ariary',
    name_plural: 'Malagasy Ariaries',
    symbol: 'MGA',
    symbol_native: 'MGA',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MKD',
    label: 'Macedonian Denar',
    name_plural: 'Macedonian denari',
    symbol: 'MKD',
    symbol_native: 'MKD',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MMK',
    label: 'Myanma Kyat',
    name_plural: 'Myanma kyats',
    symbol: 'MMK',
    symbol_native: 'K',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MNT',
    label: 'Mongolian Tögrög',
    name_plural: 'Mongolian tögrög',
    symbol: '₮',
    symbol_native: '₮',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MOP',
    label: 'Macanese Pataca',
    name_plural: 'Macanese patacas',
    symbol: 'MOP$',
    symbol_native: 'MOP$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  // {
  //   value: 'MRO',
  //   label: null,
  //   name_plural: null,
  //   symbol: null,
  //   symbol_native: null,
  //   decimal_digits: 0,
  //   category: "all",
  // rounding: 0,
  // },
  {
    value: 'MUR',
    label: 'Mauritian Rupee',
    name_plural: 'Mauritian rupees',
    symbol: 'MURs',
    symbol_native: 'MURs',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MVR',
    label: 'Maldivian Rufiyaa',
    name_plural: 'Maldivian rufiyaa',
    symbol: 'Rf',
    symbol_native: 'ރ',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MWK',
    label: 'Malawian Kwacha',
    name_plural: 'Malawian kwachas',
    symbol: 'K',
    symbol_native: 'K',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MXN',
    label: 'Mexican Peso',
    name_plural: 'Mexican pesos',
    symbol: 'MX$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MYR',
    label: 'Malaysian Ringgit',
    name_plural: 'Malaysian ringgits',
    symbol: 'RM',
    symbol_native: 'RM',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MZN',
    label: 'Mozambican Metical',
    name_plural: 'Mozambican meticals',
    symbol: 'MTn',
    symbol_native: 'MTn',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'NAD',
    label: 'Namibian Dollar',
    name_plural: 'Namibian dollars',
    symbol: 'N$',
    symbol_native: 'N$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'XPF',
    label: 'CFP Franc',
    name_plural: 'CFP franc',
    symbol: 'F',
    symbol_native: 'F',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'NGN',
    label: 'Nigerian Naira',
    name_plural: 'Nigerian nairas',
    symbol: '₦',
    symbol_native: '₦',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'NIO',
    label: 'Nicaraguan Córdoba',
    name_plural: 'Nicaraguan córdobas',
    symbol: 'C$',
    symbol_native: 'C$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'NPR',
    label: 'Nepalese Rupee',
    name_plural: 'Nepalese rupees',
    symbol: 'NPRs',
    symbol_native: 'नेरू',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'OMR',
    label: 'Omani Rial',
    name_plural: 'Omani rials',
    symbol: 'OMR',
    symbol_native: 'ر.ع.‏',
    decimal_digits: 3,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'PAB',
    label: 'Panamanian Balboa',
    name_plural: 'Panamanian balboas',
    symbol: 'B/.',
    symbol_native: 'B/.',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'PEN',
    label: 'Peruvian Nuevo Sol',
    name_plural: 'Peruvian nuevos soles',
    symbol: 'S/.',
    symbol_native: 'S/.',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'PGK',
    label: 'Papua New Guinean Kina',
    name_plural: 'Papua New Guinean kina',
    symbol: 'K',
    symbol_native: 'K',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'PHP',
    label: 'Philippine Peso',
    name_plural: 'Philippine pesos',
    symbol: '₱',
    symbol_native: '₱',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'PKR',
    label: 'Pakistani Rupee',
    name_plural: 'Pakistani rupees',
    symbol: 'PKRs',
    symbol_native: '₨',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'PLN',
    label: 'Polish Zloty',
    name_plural: 'Polish zlotys',
    symbol: 'zł',
    symbol_native: 'zł',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'PYG',
    label: 'Paraguayan Guarani',
    name_plural: 'Paraguayan guaranis',
    symbol: '₲',
    symbol_native: '₲',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'QAR',
    label: 'Qatari Rial',
    name_plural: 'Qatari rials',
    symbol: 'QR',
    symbol_native: 'ر.ق.‏',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'RON',
    label: 'Romanian Leu',
    name_plural: 'Romanian lei',
    symbol: 'RON',
    symbol_native: 'RON',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'RSD',
    label: 'Serbian Dinar',
    name_plural: 'Serbian dinars',
    symbol: 'din.',
    symbol_native: 'дин.',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'RUB',
    label: 'Russian Ruble',
    name_plural: 'Russian rubles',
    symbol: 'RUB',
    symbol_native: '₽.',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'RWF',
    label: 'Rwandan Franc',
    name_plural: 'Rwandan francs',
    symbol: 'RWF',
    symbol_native: 'FR',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SAR',
    label: 'Saudi Riyal',
    name_plural: 'Saudi riyals',
    symbol: 'SR',
    symbol_native: 'ر.س.‏',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SBD',
    label: 'Solomon Islands Dollar',
    name_plural: 'Solomon Islands dollars',
    symbol: 'SI$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SCR',
    label: 'Seychellois Rupee',
    name_plural: 'Seychellois rupee',
    symbol: 'SRe',
    symbol_native: 'SR',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SDG',
    label: 'Sudanese Pound',
    name_plural: 'Sudanese pounds',
    symbol: 'SDG',
    symbol_native: 'SDG',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SEK',
    label: 'Swedish Krona',
    name_plural: 'Swedish kronor',
    symbol: 'Skr',
    symbol_native: 'kr',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SGD',
    label: 'Singapore Dollar',
    name_plural: 'Singapore dollars',
    symbol: 'S$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SHP',
    label: 'Saint Helena Pound',
    name_plural: 'Saint Helena pound',
    symbol: 'SH£',
    symbol_native: '£',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SLL',
    label: 'Sierra Leonean Leone',
    name_plural: 'Sierra Leonean leones',
    symbol: 'Le',
    symbol_native: 'Le',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SOS',
    label: 'Somali Shilling',
    name_plural: 'Somali shillings',
    symbol: 'Ssh',
    symbol_native: 'Ssh',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SRD',
    label: 'Surinamese Dollar',
    name_plural: 'Surinamese dollars',
    symbol: 'Sr$',
    symbol_native: '$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SSP',
    label: 'South Sudanese Pound',
    name_plural: 'South Sudanese pounds',
    symbol: 'SS£',
    symbol_native: '£',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  // {
  //   value: 'STD',
  //   label: null,
  //   name_plural: null,
  //   symbol: null,
  //   symbol_native: null,
  //   decimal_digits: 0,
  //   category: "all",
  // rounding: 0,
  // },
  {
    value: 'SYP',
    label: 'Syrian Pound',
    name_plural: 'Syrian pounds',
    symbol: 'SY£',
    symbol_native: 'ل.س.‏',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'SZL',
    label: 'Swazi Lilangeni',
    name_plural: 'Swazi emalangeni',
    symbol: 'L',
    symbol_native: 'L',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'THB',
    label: 'Thai Baht',
    name_plural: 'Thai baht',
    symbol: '฿',
    symbol_native: '฿',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'TJS',
    label: 'Tajikistani Somoni',
    name_plural: 'Tajikistani somoni',
    symbol: 'SM',
    symbol_native: 'SM',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'TMT',
    label: 'Turkmenistan Manat',
    name_plural: 'Turkmenistan manat',
    symbol: 'T',
    symbol_native: 'T',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'TND',
    label: 'Tunisian Dinar',
    name_plural: 'Tunisian dinars',
    symbol: 'DT',
    symbol_native: 'د.ت.‏',
    decimal_digits: 3,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'TOP',
    label: 'Tongan Paʻanga',
    name_plural: 'Tongan paʻanga',
    symbol: 'T$',
    symbol_native: 'T$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'TRY',
    label: 'Turkish Lira',
    name_plural: 'Turkish Lira',
    symbol: 'TL',
    symbol_native: 'TL',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'TTD',
    label: 'Trinidad and Tobago Dollar',
    name_plural: 'Trinidad and Tobago dollars',
    symbol: 'TT$',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'TWD',
    label: 'New Taiwan Dollar',
    name_plural: 'New Taiwan dollars',
    symbol: 'NT$',
    symbol_native: 'NT$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'TZS',
    label: 'Tanzanian Shilling',
    name_plural: 'Tanzanian shillings',
    symbol: 'TSh',
    symbol_native: 'TSh',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'UAH',
    label: 'Ukrainian Hryvnia',
    name_plural: 'Ukrainian hryvnias',
    symbol: '₴',
    symbol_native: '₴',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'UGX',
    label: 'Ugandan Shilling',
    name_plural: 'Ugandan shillings',
    symbol: 'USh',
    symbol_native: 'USh',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'UYU',
    label: 'Uruguayan Peso',
    name_plural: 'Uruguayan pesos',
    symbol: '$U',
    symbol_native: '$',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'UZS',
    label: 'Uzbekistan Som',
    name_plural: 'Uzbekistan som',
    symbol: 'UZS',
    symbol_native: 'UZS',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'VEF',
    label: 'Venezuelan Bolívar',
    name_plural: 'Venezuelan bolívars',
    symbol: 'Bs.F.',
    symbol_native: 'Bs.F.',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'VND',
    label: 'Vietnamese Dong',
    name_plural: 'Vietnamese dong',
    symbol: '₫',
    symbol_native: '₫',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'VUV',
    label: 'Vanuatu Vatu',
    name_plural: 'Vanuatu vatu',
    symbol: 'VT',
    symbol_native: 'VT',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'WST',
    label: 'Samoan Tālā',
    name_plural: 'Samoan tālā',
    symbol: 'WS$',
    symbol_native: 'ST',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'YER',
    label: 'Yemeni Rial',
    name_plural: 'Yemeni Rials',
    symbol: 'YR',
    symbol_native: 'ر.ي.‏',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'ZAR',
    label: 'South African Rand',
    name_plural: 'South African Rand',
    symbol: 'R',
    symbol_native: 'R',
    decimal_digits: 2,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'ZMW',
    label: 'Zambian Kwacha',
    name_plural: 'Zambian Kwachas',
    symbol: 'ZK',
    symbol_native: 'ZK',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'ZWL',
    label: 'Zimbabwean Dollar',
    name_plural: 'Zimbabwean Dollars',
    symbol: 'ZWL$',
    symbol_native: 'ZWL$',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'MRU',
    label: 'Mauritanian Ouguiya',
    name_plural: 'Mauritanian ouguiya',
    symbol: 'UM',
    symbol_native: 'UM',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
  {
    value: 'STN',
    label: 'São Tomé and Príncipe Dobra',
    name_plural: 'São Tomé and Príncipe dobra',
    symbol: 'Db',
    symbol_native: 'Db',
    decimal_digits: 0,
    category: 'all',
    rounding: 0,
  },
];

export type CurrencyType = (typeof CURRENCY_LIST)[number];
export type CurrencySymbol = CurrencyType['symbol'];

export const currencyValidationSchema = {
  value: yup.string().required(),
  label: yup.string().required(),
  name_plural: yup.string().required(),
  symbol: yup.string().required(),
  symbol_native: yup.string().required(),
  decimal_digits: yup.number().required(),
  category: yup.string().required(),
  rounding: yup.number().required(),
};
